module.exports = __webpack_public_path__ + "static/img/5.8a4bbfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/5.jpg
// module id = RFuE
// module chunks = 1